var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable, Subject, combineLatest } from 'rxjs';
import { takeUntil, filter, map, distinctUntilChanged } from 'rxjs/operators';
var ViewPrintComponent = /** @class */ (function () {
    // ---------- Lifecycle ----------
    function ViewPrintComponent(store, changeDetectorRef) {
        this.store = store;
        this.changeDetectorRef = changeDetectorRef;
        // ---------- Properties ----------
        this.ngUnsubscribe = new Subject();
        this.visible = false;
    }
    // ---------- Host Listeners ----------
    ViewPrintComponent.prototype.beforePrint = function (event) {
        this.visible = true;
        this.changeDetectorRef.markForCheck();
    };
    ViewPrintComponent.prototype.afterPrint = function (event) {
        this.visible = false;
        this.changeDetectorRef.markForCheck();
    };
    ViewPrintComponent.prototype.ngOnInit = function () {
        this.initImageUrlListener();
    };
    ViewPrintComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    // ---------- Listeners ----------
    ViewPrintComponent.prototype.initImageUrlListener = function () {
        var _this = this;
        combineLatest(this.storyChapters$, this.store.select(StoryChaptersState.getRegisteredThumbnails))
            .pipe(filter(function (_a) {
            var _b = __read(_a, 2), chapters = _b[0], thumbnails = _b[1];
            return chapters.length > 0 && thumbnails.size > 0;
        }), map(function (_a) {
            var _b = __read(_a, 2), chapters = _b[0], thumbnails = _b[1];
            return thumbnails.get(chapters[0].id).urls.large;
        }), distinctUntilChanged(), takeUntil(this.ngUnsubscribe))
            .subscribe(function (imageUrl) {
            _this.imageUrl = imageUrl;
            _this.changeDetectorRef.markForCheck();
        });
    };
    __decorate([
        Select(StoryChaptersState.getStoryChapters),
        __metadata("design:type", Observable)
    ], ViewPrintComponent.prototype, "storyChapters$", void 0);
    return ViewPrintComponent;
}());
export { ViewPrintComponent };
